export const convertirSegundosTiempo = (segundosP) => {
    const segundos = (Math.round(segundosP % 0x3C)).toString();
    const horas = (Math.floor(segundosP / 0xE10)).toString();
    const minutos = (Math.floor(segundosP / 0x3C) % 0x3C).toString();

    return `${horas}h:${minutos}m:${segundos}:s`

}